import { Component, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Router } from 'express';
import moment from 'moment';
import Swal from 'sweetalert2';
import { Responsables, Meses, obtenerError, obtenerTamMax } from '../../../models/Formulacion/indicadores-metas/datos';
import { DataService } from '../../../services/data/data.service';
import { ExcelService } from '../../../services/excel/excel.service';
import { ActasService } from '../../../services/seguimiento/actas/actas.service';
import { FiltersM } from '../../../components/models';
import { CookieService } from 'ngx-cookie-service';
import { messages } from '../../funciones/mensajes';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { ResponsableService } from '../../../services/gestion/responsable/responsable.service';
import { PlanesService } from '../../../services/gestion/planes/planes.service';
import { PERMISOS } from '../../../shared/catalogos';
@Component({
  selector: 'app-planes',
  templateUrl: './planes.component.html',
  styleUrl: './planes.component.css'
})
export class PlanesComponent {
  public readonly permisos = PERMISOS;
  public Filters = FiltersM;
/* Variables de plan */
  private idPlaneacion = 0;

  /* Variables de edición en tabla */
  private edicion: boolean;
  private semaforo: any = [];
  /* Variables de funcionamiento de tablas */
  public mostabla = false;
  public skeleton = new Array(15);
  public skeletonColums = new Array(6);
  public mostrarAllActas = false;
  public actividadesFull: any = [];
  public adicionales = [];
  public  ordenamiento = 'id';
  private fechaAct = new Date();
  /* Variables de las tabla */
  private actas = [];
  public actasMostrar = [];
  public actividadesActas = [];
  /* Variables de filtros */
  public aniosDisponibles = [];
  public diasLab;
  public Periodo = '';
  public responsables: Responsables[] =[];
  public responsablesActas: Responsables[] = [];
  public responsablesActividadesActas: Responsables[] = [];
  public selecAllResActas = true;
  public selecAllResActiv = true;
  /* Variables para el formateo de cantidades */
  public separador:string =  ","; // separador para los miles
  public sepDecimal:string = '.'; // separador para los decimales
  /** Lectura de archivos */
  selectedFiles: FileList;
  //Es el array que contiene los items para mostrar el progreso de subida de cada archivo
  progressInfo = [];
  message = '';
  imageName = "";
  /** click izquierdo */
  @ViewChild(MatMenuTrigger, {static: true}) matMenuTrigger: MatMenuTrigger;

  menuTopLeftPosition =  {x: '0', y: '0'};
  private adDelete : any;
  private adActivi : any;

  public maxAdi = [];

  constructor(
    public dataService: DataService,
    private rutaActiva: ActivatedRoute,
    private excelService: ExcelService,
    private translate: TranslateService,
    private cookieService: CookieService,

    private readonly planificacionService: PlanificacionService,
    private readonly responsableService: ResponsableService,
    private readonly actaService: PlanesService,
  ) {
    this.idPlaneacion = Number(cookieService.get('idInstitucion'));
    this.obtenerDatos();
    moment.updateLocale('en',{
      months: [
        "Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto",
        "Septiembre","Octubre","Noviembre","Diciembre"
      ],
      monthsShort: [
        "Ene","Feb","Mar","Abr","May","Jun","Jul","Ago",
        "Sep","Oct","Nov","Dic"
      ]
    });
  }
  ngOnInit(): void {
  }
  /* Consultas para obtención de información */
  private async obtenerDatos(){
    try{
      this.idPlaneacion = Number(this.cookieService.get('idInstitucion'));
      const plan = await this.planificacionService.getPlanificacionByIdGQL(this.idPlaneacion);
      await this.obtenerFiltros(plan);
      const res2 = await this.actaService.getActasGql(`${this.idPlaneacion}`);
      this.obtenerActas(res2);
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  /* Extracción de datos */
  // Filtros
  private seleccionarPeriodo(){
    this.aniosDisponibles.forEach(a => {
      a.series.forEach(m => m.check = false);
    });
    const ultimoAnio = this.aniosDisponibles[this.aniosDisponibles.length - 1];
    const ultimoPeriodo = ultimoAnio.series[ultimoAnio.series.length - 1];

    const periodoActual = moment().format('MMM-YY').toLowerCase();

    if (ultimoPeriodo.periodo === periodoActual) {
      const series = ultimoAnio.series;
      const indice = series.length - 1;

      if (indice > 0) {
        series[indice - 1].check = true;
        this.Periodo = series[indice - 1].periodo;
      }
    } else {
      ultimoPeriodo.check = true;
      this.Periodo = ultimoPeriodo.periodo;
    }
  }
  private async obtenerFiltros(planeacion: any){
    this.edicion = planeacion.isActive;
    const sema = this.ordenamientoSem(planeacion.signals);
    if( Number(sema[sema.length-1].value_01) > 100){
      const valFinal = Number(sema[sema.length-1].value_01); 
      for(const sem of sema){
        this.semaforo.push({
          valIn: Math.round((Number(sem.value_00)*100)/valFinal) === 0? Math.round((Number(sem.value_00)*100)/valFinal):Math.round((Number(sem.value_00)*100)/valFinal)+0.1,
          valfin: Math.round((Number(sem.value_01)*100)/valFinal),
          color: sem.color[0],
        });
      }      
    }else{
      for(const sem of sema){
        this.semaforo.push({
          valIn: Number(sem.value_00),
          valfin: Number(sem.value_01),
          color: sem.color[0],
        });
      }
    }

    this.diasLab = planeacion.business_days;
    this.aniosDisponibles = Meses.obtenerPeriodos(moment(planeacion.initial_date).toDate(), moment(planeacion.end_date).toDate());
    this.seleccionarPeriodo();

    try{
      const res = await lastValueFrom(this.responsableService.getResponsable());
      this.responsables = [];
        var aux = [];
        for(const are of res){
          if(are.institution.id === planeacion.institution.id){
            for(const res of are.responsibles){
              aux.push({
                nombre: res.position,
                id: res.id,
                check: true,
                isValidator: res.isValidator,
              });
            }
          }
        }
        this.responsables = this.ordenamientoAlf(aux);
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  // Actas
  private obtenerActas(array: any){
    var auxiliar = [];
    this.actividadesFull = [];
    for(const acta of array){
      var aux = [];
      for(const acti of acta.activities){
        var hist = [];
        var historicosCom = Meses.obtenerPlaneado(new Date(acti.initial_date), new Date(acti.end_date), this.diasLab);
        let hisAg = 0;
        for(const his of historicosCom){
          const ex = acti.history.filter(h => h.period === his.periodo);
          if(ex.length !== 0){
            hist.push({
              periodo: ex[0].period,
              planeado: Number(ex[0].planned),
              ejecutado: ex[0].executed,
              id: ex[0].id,
            });
            hisAg++;
          }else{
            hist.push({
              periodo: his.periodo,
              planeado: Number(his.planeado),
              ejecutado: his.ejecutado,
              id: his.id,
            });
          }
        }
        if(hisAg !== acti.history.length){
          for(const h of acti.history){
            const ex = hist.filter(hi => hi.periodo === h.period);
            if(ex.length === 0){
              hist.push({
                periodo: h.period,
                planeado: Number(h.planned),
                ejecutado: h.executed,
                id: h.id,
              });
            }
          }
        }
        hist = this.ordenamientoHis(hist);
        aux.push({
          nombre: acti.name,
          fecha_inicio: moment(acti.initial_date.split('T')[0]),
          fecha_fin: moment(acti.end_date.split('T')[0]),
          projectId: acta.id,
          responsable: acti.responsible,
          validacion: acti.validated,
          completada: acti.completed,
          id: acti.id,
          adicionales: this.ordenamientoAdi(acti.additions),
          history: hist,
        });
      }
      this.actividadesFull = this.actividadesFull.concat(aux);
      auxiliar.push({
        nombre: acta.name,
        descripcion: acta.description,
        responsable: acta.validator,
        acta: acta.attachment,
        id: acta.id,
        check: true,
        fecha_ini: undefined,
        fecha_fin: undefined,
        actividades: aux,
      });
    }
    this.actas = auxiliar;
    this.actas = this.ordenamientoPer(this.actas);

    this.obtenerfechasActas();
    this.adicionales = this.actas[0].actividades[0]?.adicionales.length > 0? this.actas[0].actividades[0]?.adicionales.map( r => { return {...r}}): [];
    this.dataTablaMostrar('cam');
    this.obtResponsableDinamico();
    this.mostabla = true;
  }
  //Actividades de las actas
  private actividadIncompleta(act: any){ //checar
    var mes = Meses.getMesesS(this.Periodo.split('-')[0])<10?'0'+Meses.getMesesS(this.Periodo.split('-')[0]):''+Meses.getMesesS(this.Periodo.split('-')[0]);
    const momentAct = moment('01-'+mes+'-20'+this.Periodo.split('-')[1], 'DD-MM-YYYY');

    var fechaFinAct;
    if((act.fecha_fin+'').includes('Z')){
      fechaFinAct = this.obtFech(act.fecha_fin);
    }else{
      fechaFinAct = act.fecha_fin;
    }
    const momnetFinAct = moment(fechaFinAct);
    
    if(momentAct.isAfter(momnetFinAct) && act.completada !== true){
      return true;
    }
    return false;
  }
  //Adicionales de las actividades
  private obtenerAdicionalesActividades(array){
    if(this.actas.length !== 0){
      for(const acta of this.actas){
        if(acta.actividades.length !== 0){
          for(const act of acta.actividades){
            var adicional = array.filter(adi => adi.activity !== null && adi.activity.id === act.id);
            adicional = this.ordenamientoAdi(adicional);
            act.adicionales = adicional;
          }
        }
      }
      this.obtenerfechasActas();
      this.adicionales = this.actas[0].actividades[0].adicionales;
      this.dataTablaMostrar('cam');
      this.obtResponsableDinamico();
    }
    this.mostabla = true;
  }
  /** Obtención de los datos */
  //Fechas de proyectos
  public obtenerfechasActas(){
    for(const pro of this.actas){
      for(const act of pro.actividades){
        if(pro.fecha_ini === undefined){
          pro.fecha_ini = act.fecha_inicio;
        }else{
          if(pro.fecha_ini > act.fecha_inicio){
            pro.fecha_ini = act.fecha_inicio;
          }
        }
        if(pro.fecha_fin === undefined){
          pro.fecha_fin = act.fecha_fin;
        }else{
          if(pro.fecha_fin < act.fecha_fin){
            pro.fecha_fin = act.fecha_fin;
          }
        }
      }
    }
  }
  //Obtención de fechas
  public obtFecha(fec: any){
    var fecha =  '';
    if(fec != undefined){
      return fec.format('DD-MM-YYYY');
    }else{
      return '';
    }
  }
  /* Obtención de datos a mostrar */
  public dataTablaMostrar(parametros: any){
    var actasTot = [].concat(this.actas);    
    this.actasMostrar = [];
    for(const acta of actasTot){
      switch(parametros){
        case 'all':
          if( this.mostrarConResponsables(acta) ){
            this.actasMostrar.push({
              nombre: acta.nombre,
              descripcion: acta.descripcion,
              responsable: acta.responsable,
              acta: acta.acta,
              id: acta.id,
              check: acta.check,
              fecha_ini: acta.fecha_ini,
              fecha_fin: acta.fecha_fin,
              actividades: acta.actividades,
            });
          }
        break;
        case 'cam':
          if( this.mostrar(acta) ){
            this.actasMostrar.push(acta);
          }
        break;
      }
    }
    if(parametros === 'all' && !this.selecAllResActiv){
      const res = this.responsablesActividadesActas.filter(res => res.check===true);
      if(res.length!==0){
        for(const a of this.actasMostrar){
          const act = a.actividades.filter(act => this.responsableActOfActas(act)===true);
          a.actividades = act;
        }        
      }
    }
  }
  //Obtención de responsables
  private obtResponsableDinamico(){
    var aux = [], aux2 = [];
    for(const acta of this.actasMostrar){
      const res = this.responsables.filter(res => res.id === acta.responsable.id);
      const existe = aux.filter(res => res.id === acta.responsable.id);
      if(existe.length === 0){
        aux.push({
          nombre: res[0].nombre,
          name: res[0].nombre,
          id: res[0].id,
          check: true,
        });
      }
      for(const resp of acta.actividades){
        const resAct = this.responsables.filter(res => res.id === resp.responsable.id);
        const existeAct = aux2.filter(res => res.id === resp.responsable.id);
        if(existeAct.length === 0){
          aux2.push({
            nombre: resAct[0].nombre,
            name: resAct[0].nombre,
            id: resAct[0].id,
            check: true,
          });
        }
      }
    }
    this.responsablesActas = this.ordenamientoAlf(aux);
    this.selecAllResActas = true;
    this.responsablesActividadesActas = this.ordenamientoAlf(aux2);
    this.selecAllResActiv = true;
  }
  //Mostrar sin considerar responsable
  public mostrar(acta: any){
    const per = this.perSelected(); 
    for(const acti of acta.actividades){
      const dat = acti.history.filter( his => his.id !== 0);
      acti.history = dat;
      if( (!acti.completada || acti.completada === null) && this.actividadIncompleta(acti) ){
        const filter = acti.history.filter(his => his.periodo === per);
        if(filter.length === 0){
          acti.history.push({
            periodo: per,
            planeado: 100,
            ejecutado: null,
            id: 0,
          });
        }
      }
    }
    let tieneAct = false;
    for(const acti of acta.actividades){
      const filter = acti.history.filter(his => his.periodo === per);
      if(filter.length !== 0 && (!acti.completada || acti.completada === null)){
        tieneAct = true;
      }    
    }    
    if( this.existeAnio(acta) || tieneAct ){
      return true;
    }else{
      return false;
    }
  }
  //Mostrar considerando los responsables
  public mostrarConResponsables(acta: any){
    const per = this.perSelected(); 
    for(const acti of acta.actividades){
      const dat = acti.history.filter( his => his.id !== 0);
      acti.history = dat;
      if( (!acti.completada || acti.completada === null) && this.actividadIncompleta(acti) ){
        const filter = acti.history.filter(his => his.periodo === per);
        if(filter.length === 0){
          acti.history.push({
            periodo: per,
            planeado: 100,
            ejecutado: null,
            id: 0,
          });
        }
      }
    }

    let tieneAct = false;
    for(const acti of acta.actividades){
      const filter = acti.history.filter(his => his.periodo === per);
      if(filter.length !== 0 && (!acti.completada || acti.completada === null) && this.responsableActOfActas(acti)){
        tieneAct = true;
      }    
    }
    if( this.responsableActas(acta) && tieneAct ){
      
      return true;
    }else{
      return false;
    }
  }
  //Metodos de decición
  private existeAnio(acta: any){ //checar
    if(acta.fecha_ini !== undefined && acta.fecha_fin !== undefined){
      var fecha_ini = Number(moment(acta.fecha_ini).format('YYYY')), fecha_fin = Number(moment(acta.fecha_fin).format('YYYY'));
      for(const an of this.aniosDisponibles){
        if(an.check === true && (Number(an.name) >= fecha_ini && Number(an.name) <= fecha_fin) ){
          return true;
        }
      }
      return false;
    }else{
      return false;
    }
  }
  private responsableActas(acta: any){
    for(const res of this.responsablesActas){
      if(res.id === acta.responsable.id && res.check){
        return true;
      }
    }
    return false;
  }
  public responsableActOfActas(act: any){
    for(const res of this.responsablesActividadesActas){
      if(res.id === act.responsable.id && res.check){
        return true;
      }
    }
    return false;
  }
  // Metodos de busqueda
  private perSelected(){
    for(const an of this.aniosDisponibles){
      for(const mes of an.series){
        if(mes.check){
          return mes.periodo;
        }
      }
    }
    return '';
  }
  /* Funcionamiento de los filtros */
  //Filtro de años
  public cambioAnio(per: any){
    for(const an of this.aniosDisponibles){
      for(const mes of an.series){
        mes.periodo === per.periodo? mes.check = true: mes.check = false;        
        mes.periodo === per.periodo? this.Periodo = mes.periodo: '';
      }
    }
    this.dataTablaMostrar('cam');
    this.obtResponsableDinamico();
  }
  //Filtro de lider actas
  public cambioLider(pers){
    if(pers !== 'consolidado'){
      this.responsablesActas.forEach(res =>{ res.nombre === pers.nombre? res.check = !res.check: res.check = res.check});
      var all = 0;
      this.responsablesActas.forEach(res =>{ res.check? all++ : all = all });
      if(all === this.responsablesActas.length){
        this.selecAllResActas = true
      }else{
        this.selecAllResActas = false;
      }
    }else{
      if(this.selecAllResActas){
        this.responsablesActas.forEach(res =>{ res.check = false});
      }else{
        this.responsablesActas.forEach(res =>{ res.check = true});
      }
      this.selecAllResActas = !this.selecAllResActas
      
    }
    if( pers !== undefined || this.selecAllResActas){
      this.dataTablaMostrar('all');
    }
  }
  public selecAllLideres(){
    this.responsablesActas.forEach(res => this.selecAllResActas?res.check=false:res.check=true);
    this.selecAllResActas = !this.selecAllResActas;
    if(this.selecAllResActas){
      this.dataTablaMostrar('all');
    }
  }
  //Filtro de responsable actividades
  public cambioResponsable(pers){
    if(pers != 'consolidado'){
      this.responsablesActividadesActas.forEach(res =>{ res.nombre === pers.nombre? res.check = !res.check: res.check = res.check});
      var all = 0;
      this.responsablesActividadesActas.forEach(res =>{ res.check? all++ : all = all });
      if(all === this.responsablesActividadesActas.length){
        this.selecAllResActiv = true
      }else{
        this.selecAllResActiv = false;
      }
    }else{
      if(this.selecAllResActiv){
        this.responsablesActividadesActas.forEach(res =>{ res.check = false});
      }else{
        this.responsablesActividadesActas.forEach(res =>{ res.check = true});
      }
      this.selecAllResActiv = !this.selecAllResActiv
    }
    if( pers !== undefined || this.selecAllResActiv){
      this.dataTablaMostrar('all');
    }
  }
  public selecAllResponsables(){
    this.responsablesActividadesActas.forEach(res => this.selecAllResActiv?res.check=false:res.check=true);
    this.selecAllResActiv = !this.selecAllResActiv;
    if(this.selecAllResActiv){
      this.dataTablaMostrar('all');
    }
  }
  //Vision de los tres puntos
  public tresPuntosVis(){
    var sel = 0;
    for(const res of this.responsablesActas){
      if(res.check){
        sel++;
      }
    }
    if(sel <= 1)
      return false;
    return true;
  }
  public tresPuntosVisResp(){
    var sel = 0;
    for(const res of this.responsablesActividadesActas){
      if(res.check){
        sel++;
      }
    }
    if(sel <= 1)
      return false;
    return true;
  }
  /** Borrar filtros */
  public borrarFiltro(){
    document.body.style.cursor = 'wait';

    this.Periodo = this.aniosDisponibles[this.aniosDisponibles.length-1].series[this.aniosDisponibles[this.aniosDisponibles.length-1].series.length-1].periodo;
    for(const an of this.aniosDisponibles){
      for(const mes of an.series){
        if(mes.periodo !== this.Periodo){
          mes.check = false;
        }else{
          mes.check = true;
        }
      }
    }
    
    this.responsablesActas.forEach(res => res.check = true);
    this.responsablesActividadesActas.forEach(res => res.check = true);

    this.ordenamiento = 'id';

    this.dataTablaMostrar('cam');
    this.obtResponsableDinamico();

    setTimeout(() => {
      document.body.style.cursor = 'default';        
    }, 2000 );
  }
  /** Metodo de obtención de fecha */
  private obtFech(fec: any){
    if(fec !== undefined){
      return fec.format('DD-MM-YYYY')
    }else{
      return '';
    }
  }
  /* Eventos de tablas */
  public mostrarTodasLasActas(){
    this.actasMostrar.forEach(acta => this.mostrarAllActas?acta.check=false:acta.check=true)
    this.mostrarAllActas = !this.mostrarAllActas;
  }
  public mostrarActas(acta: any){
    acta.check = !acta.check;
    var actasAbiertas = 0;
    for(const actas of this.actasMostrar){
      if(actas.check){
        actasAbiertas++;
      }
    }
    if(actasAbiertas === this.actasMostrar.length){
      this.mostrarAllActas = true;
    }else if(actasAbiertas === 0){
      this.mostrarAllActas = false;
    }
  }
  public existAct(act: any){ //checar
    var existePeriodo = false;
    var per_sel = this.perSelected();
    if(act.fecha_inicio != undefined && act.fecha_fin != undefined){
      var per1 = Meses.getMesesN(new Date(act.fecha_inicio).getMonth()+1) + '-' + (''+new Date(act.fecha_inicio).getFullYear()).substring(2,4);
      var per2 = Meses.getMesesN(new Date(act.fecha_fin).getMonth()+1) + '-' + (''+new Date(act.fecha_fin).getFullYear()).substring(2,4);
      existePeriodo = Meses.compararPer(per1, per2, per_sel);
    }
    let actComp = this.actividadIncompleta(act);    
    const per = this.perSelected(); 
    const filter = act.history.filter(his => his.periodo === per);
    if(filter.length !== 0 && (existePeriodo || actComp)){
      return true
    }
    return false;
  }
  public async abrirArchivo(acta: any){
    try{
      const response = await firstValueFrom(this.actaService.getFileActas(acta)); 
      let fileName = acta.acta;
      switch(fileName.split('.')[fileName.split('.').length-1]){
        case 'pdf':
          const mediaType = 'application/pdf';
          const blob = new Blob([response], { type: mediaType });
          const nav = (window.navigator as any);

          if (nav.msSaveOrOpenBlob)  {
            nav.msSaveOrOpenBlob(blob, fileName);
          } else {
            const a = document.createElement('a');
            const url = URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            window.open(""+a.href,"_blank");

            setTimeout(function() {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);  
            }, 0); 
          }
        break;
        case 'png':
        case 'jpg':
          const mediaTypei = 'image/'+fileName.split('.')[fileName.split('.').length-1];
          const blobi = new Blob([response], { type: mediaTypei });
          const navi = (window.navigator as any);

          if (navi.msSaveOrOpenBlob)  {
            navi.msSaveOrOpenBlob(blobi, fileName);
          } else {
            const a = document.createElement('a');
            const url = URL.createObjectURL(blobi);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            window.open(""+a.href,"_blank");
            a.click();

            setTimeout(function() {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);  
            }, 0); 
          }
        break;
        default:
          const mediaTyped = 'aplication/'+fileName.split('.')[fileName.split('.').length -1];
          const blobd = new Blob([response], { type: mediaTyped });
          const navd = (window.navigator as any);

          if (navd.msSaveOrOpenBlob)  {
            navd.msSaveOrOpenBlob(blobd, fileName);
          } else {
            const a = document.createElement('a');
            const url = URL.createObjectURL(blobd);
            a.href = url;
            a.download = fileName.split('-')[fileName.split('-').length -1];
            document.body.appendChild(a);
            a.click();

            setTimeout(function() {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);  
            }, 0); 
          }
        break;
      }
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  /* Escritura en tabla */
  public obtenerDias(fIni: any, fFin: any){
    var dias = 0;
    var diff = fFin.diff(fIni, 'days');
    if(diff === 0){
      diff = 1;
    }
    switch(this.diasLab){
      case 'Lunes-Viernes':
        var sem = Math.trunc(diff/7);
        dias = diff - sem*2;
      break;
      case 'Lunes-Sabado':
        var sem = Math.trunc(diff/7);
        dias = diff - sem;
      break;
      case 'Lunes-Domingo':
        dias = diff;
      break;
    }
    return dias;
  }
  //Escribir datos
  public escribirDat(historico: any, tip: string){
    var per = this.perSelected();
    if(historico){
      for(const dat of historico){
        if(per === dat.periodo){
          if(tip === 'plan'){
            return dat.planeado;
          }else if(tip === 'ejec'){
            return dat.ejecutado;
          }
        }
      }
    }
  }
  public escribirDatPro(acta: any, tip: string){
    return this.avancesProyectos(acta, tip);
  }
  // Avance acumulado
  public obtenerAvanceAcumPro(acta){
    var per = this.perSelected();
    var dias = 0, porcentajeplan = 0;
    for(const act of acta.actividades){
      dias += this.obtenerDias(act.fecha_inicio,act.fecha_fin);
    }
    for(const act of acta.actividades){
      let avance = this.avanceAcumulado(act, per);
      var diasAct = this.obtenerDias(act.fecha_inicio,act.fecha_fin); //checar
      var pesoAct = Number((diasAct*100/dias).toFixed(2));
      porcentajeplan += Number((avance*pesoAct/100).toFixed(2));

    }
    return Number(porcentajeplan.toFixed(2));
  }
  public avanceAcumulado(act: any, per?: any){
    if(per === undefined){
      per = this.perSelected();
    }
    var valFin = 0;
    var res = this.actividadesFull.filter(ac => ac.id === act.id);
    if(res.length !== 0){
      var hist = res[0].history;
      hist = this.ordenamientoId(hist);
      hist = this.ordenamientoPlaneado(hist);
      for(const h of hist){
        if(per !== h.periodo){
          if(h.ejecutado !== null){
            valFin = h.ejecutado;
          }
        }else{
          if(h.ejecutado !== null){
            valFin = h.ejecutado;
          }
          break;
        }
      }
    }
    return valFin;
  }
  //Bordes
  public pintarBordPro(eje: any, plan: any){
    if(eje !== 0){
      var color = '';
      var por = eje*100/plan;
      var valfin = 0;
      for(const sem of this.semaforo){
        if(valfin < sem.valfin){
          valfin = sem.valfin
        }
      }
      if(por >= valfin){
        por = valfin-1;
      }
      for(const sem of this.semaforo){
        var ab = sem.valIn;
        if(ab !== 0){
          ab = ab-0.1;
        }
        if(por >= ab && por <= sem.valfin){
          color = sem.color;
          break;
        }
      }
      switch(color){
        case 'verde': return 'bordeVerde';
        case 'azul': return 'bordeAzul';
        case 'amarillo': return 'bordeAmarillo';
        case 'naranja': return 'bordeNaranja';
        case 'rojo': return 'bordeRojo';
        default:  return 'bordeGrey';
      }
    }
    return 'bordeGris'
  }
  public pintarBord(eje: any, plan: any){
    var porcentaje = undefined;
    var color = '';
    if(eje === 0 && plan !== 0 /*&& this.dataService.company_name === 'Unión Popular'*/){//'Raiffeisen Latina' ){//
      return 'bordeNegro';
    }else if(eje === 0 && plan !== 0){
      porcentaje = 0;
    }else if(eje !== 0 && eje !== null){
      porcentaje = eje*100/plan;
      
    }
    if(porcentaje !== undefined){
      var valfin = 0;
      for(const sem of this.semaforo){
        if(valfin < sem.valfin){
          valfin = sem.valfin
        }
      }
      if(porcentaje >= valfin){
        porcentaje = valfin-1;
      }
      for(const sem of this.semaforo){
        var ab = sem.valIn;
        if(ab !== 0){
          ab = ab-0.1;
        }
        if(porcentaje >= ab && porcentaje <= sem.valfin){
          color = sem.color;
          break;
        }
      }
      switch(color){
        case 'verde': return 'bordeVerde';
        case 'azul': return 'bordeAzul';
        case 'amarillo': return 'bordeAmarillo';
        case 'naranja': return 'bordeNaranja';
        case 'rojo': return 'bordeRojo';
        default:  return 'bordeGrey';
      }
    }
    return 'bordeGris'
  }
  //Escritura de los adicionales
  public escribirAdicionalPro(actividades: any, i: number){
    var presTot = 0;
    var presTotN = 0;
    for(const act of actividades){
      if(act.adicionales[i] !== null && act.adicionales[i].type === 'moneda'){
        presTot += act.adicionales[i].amount;
      }
    }
    if(actividades[0].adicionales[i].type === 'moneda'){
      return this.formatearnormal(presTot);
    }else{
      return '';
    }
  }
  public escribirAdicional(adic: any){
    if(adic != undefined){
      switch(adic.type){
        case 'texto':
          return this.obtComment(adic.comments);
        case 'moneda':
          return this.formatearnormal(adic.amount);
        case 'numero':
          return this.obtCommentNumero(adic.comments);
        case 'archivo':
          var per  = this.perSelected();
          for(const file of adic.files){
            if (per === Meses.obtnerPer(moment(file.createdAt).toDate())) {
              return file.name.split('-')[file.name.split('-').length - 1];
            }
          }
          return '';
      }
    }
  }
  private obtCommentNumero(com : any){
    for(const comen of com){
      var per = 0;
      for(const an of this.aniosDisponibles){
        for(const mes of an.series){
          if(mes.check){
            per = an.anio;
          }
        }
      }
      var percom = new Date(comen.created_at).getFullYear(); //checar
      if(per === percom){
        return comen.comment;
      } 
    }
    return '';
  }
  private obtComment(com : any){ //checar
    for(const comen of com){
      var per =  this.perSelected();
      var percom = Meses.obtnerPer(new Date(comen.createdAt));
      if(per === percom){
        return comen.comment;
      }
    }
    return '';
  }
  // Abrir adicionales
  public async abirPDF(ad, event?: any){
    const per = this.perSelected();
    for(const fil of ad.files){
      if(Meses.obtnerPer(new Date(fil.created_at)) === per){
        try{
          const response = await firstValueFrom(this.actaService.getFile(ad.id, fil.id)); 
          switch(fil.name.split('.')[fil.name.split('.').length-1]){
            case 'pdf':
              const mediaType = 'application/pdf';
              const blob = new Blob([response], { type: mediaType });
              const nav = (window.navigator as any);

              if (nav.msSaveOrOpenBlob)  {
                nav.msSaveOrOpenBlob(blob, fil.name);
              } else {
                const a = document.createElement('a');
                const url = URL.createObjectURL(blob);
                a.href = url;
                a.download = fil.name;
                document.body.appendChild(a);
                window.open(""+a.href,"_blank");

                setTimeout(function() {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);  
                }, 0); 
              }
            break;
            case 'png':
            case 'jpg':
              const mediaTypei = 'image/'+fil.name.split('.')[fil.name.split('.').length-1];
              const blobi = new Blob([response], { type: mediaTypei });
              const navi = (window.navigator as any);

              if (navi.msSaveOrOpenBlob)  {
                navi.msSaveOrOpenBlob(blobi, fil.name);
              } else {
                const a = document.createElement('a');
                const url = URL.createObjectURL(blobi);
                a.href = url;
                a.download = fil.name;
                document.body.appendChild(a);
                window.open(""+a.href,"_blank");
                a.click();

                setTimeout(function() {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);  
                }, 0); 
              }
            break;
            default:
              const mediaTyped = 'aplication/'+fil.name.split('.')[fil.name.split('.').length -1];
              const blobd = new Blob([response], { type: mediaTyped });
              const navd = (window.navigator as any);

              if (navd.msSaveOrOpenBlob)  {
                navd.msSaveOrOpenBlob(blobd, fil.name);
              } else {
                const a = document.createElement('a');
                const url = URL.createObjectURL(blobd);
                a.href = url;
                a.download = fil.name.split('-')[fil.name.split('-').length -1];
                document.body.appendChild(a);
                a.click();

                setTimeout(function() {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);  
                }, 0); 
              }
            break;
          }
        }catch(err){
          messages.errorMessageGraph(err);
        }
      }
    }
  }
  public editar(his: any, idAct: any){
    var perSel = '';
    for(const an of this.aniosDisponibles){
      for(const mes of an.series){
        if(mes.check){
          perSel = mes.periodo;
        }
      }
    }
    var perAct = Meses.obtnerPer(this.fechaAct);
    var perAnt = Meses.obtnerPerAnt(this.fechaAct);
    if(this.edicion){
      this.dat(his,perSel,idAct);
      return ;
    }else if(Meses.compararPer(perAnt,perAct,perSel)){
      this.dat(his,perSel,idAct)
    }else{
      Swal.fire({
        title: this.translate.instant('gestion.seguimiento.planes.noedit'),
        text: this.translate.instant('gestion.seguimiento.planes.noedit2'),
        confirmButtonColor: '#ff6b00',
        cancelButtonColor: '#B9B9BC',
        confirmButtonText: this.translate.instant('swal.acep'),
        cancelButtonText: this.translate.instant('swal.cerr'),
      });
    }
    
  }
  public async dat(his: any, perSel: any, idAct: any){
    var inputValue = 0, introdujo: any, guardo = false;
    
    for(const per of his){
      if(per.periodo === perSel){
        inputValue = per.ejecutado;
      }
    }

    introdujo = await Swal.fire({
      title: this.translate.instant('gestion.seguimiento.planes.ingrese'),
      text: "",
      input: 'number',
      inputValue: inputValue,
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (Number(value) > 100) {
          return this.translate.instant('gestion.seguimiento.planes.datoInv');
        }
        guardo = true;
        return '';
      }
    });

    if(guardo){
      try{
        const reg = his.find(h => h.periodo === perSel);
        if(reg.id !== 0 && introdujo.value !== ''){
          for(const per of his){
            if(per.periodo === perSel){
              if(introdujo.value !== ''){
                per.ejecutado = Number(introdujo.value);
              }else{
                per.ejecutado = null;
              }
              const res = await firstValueFrom(this.actaService.PatchHistorico(per, Number(per.id))); 
              messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
            }
          }
        }else if(reg.id === 0 && introdujo.value !== ''){
          reg.ejecutado = Number(introdujo.value);
          const res = await firstValueFrom(this.actaService.postHistorico(reg, Number(idAct))); 
          reg.id = res.id;
          messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
        }else if(reg.id !== 0 && introdujo.value === ''){
          try{
            await this.actaService.deleteHistorico(reg);
            messages.succesMessageGraph(this.translate.instant('swal.swalElimino'));
            reg.id = 0;
            reg.ejecutado = null;
          }catch(err){
            messages.errorMessageGraph(err);
          }
        }
      }catch(err){
        messages.errorMessageGraph(err);
      }      
    }
  }
  public async edicionAd(adic: any, id: any, event?: any){
    var inputValue : any, introdujo: any, guardo = false;
    switch(adic.type){
      case 'texto':
        inputValue =  this.obtComment(adic.comments);
        introdujo = await Swal.fire({
          title: this.translate.instant('gestion.seguimiento.planes.ingComen'),
          text: "",
          input: 'text',
          inputValue: inputValue,
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: this.translate.instant('swal.acep'),
          cancelButtonText: this.translate.instant('swal.cerr'),
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            guardo = true;
            return '';
          }
        });
      break;
      case 'moneda':
        inputValue =  adic.amount;
        introdujo = await Swal.fire({
          title: this.translate.instant('gestion.seguimiento.planes.ingMonto'),
          text: "",
          input: 'number',
          inputValue: inputValue,
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: this.translate.instant('swal.acep'),
          cancelButtonText: this.translate.instant('swal.cerr'),
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            if (!value) {
              return this.translate.instant('gestion.seguimiento.planes.datoInv2');
            }
            guardo = true;
            return '';
          }
        });
      break;
      case 'archivo':
        inputValue =  adic.file;
        introdujo = await Swal.fire({
          title: this.translate.instant('gestion.seguimiento.planes.selecArch'),
          text: "",
          input: 'file',
          inputValue: inputValue,
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: this.translate.instant('swal.acep'),
          cancelButtonText: this.translate.instant('swal.cerr'),
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            if (!value) {
              return this.translate.instant('gestion.seguimiento.planes.datoInv2');
            }
            guardo = true;
            return '';
          }
        });
      break;
    }

    if(guardo){
      try{
        switch(adic.type){
          case 'texto':
            var existe = false;
            var per =  this.perSelected();
            for(const comen of adic.comments){
              var percom = Meses.obtnerPer(new Date(comen.createdAt));
              if(per === percom){
                comen.comment = introdujo.value==''?' ':introdujo.value;
                existe = true;
                const res = await firstValueFrom(this.actaService.patchComment(comen, adic.id));
                messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
              }
            }
            if(!existe){
              var date = (new Date(Meses.getMesesS(per.split('-')[0])+'-1-'+per.split('-')[1]));
              adic.comments.push({
                comment: introdujo.value,
                createdAt: date.toISOString(),
              });
              var aux = {
                comment: introdujo.value,
                createdAt: date.toISOString()
              }
              const res = await firstValueFrom(this.actaService.postComment(aux, adic.id)); 
              messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
            }
          break;
          case 'moneda':
            adic.amount = introdujo.value;
          break;
          case 'archivo':
            this.progressInfo = [];
            introdujo.value ? this.imageName = introdujo.value.name : this.imageName = introdujo.value.length + " archivos";
            this.selectedFiles = introdujo.value;
            var per  = this.perSelected();
            var existe = false;
            if( this.selectedFiles["size"] > obtenerTamMax.getPeso() ){
              messages.errorMessageGraph(obtenerTamMax.getTexto());
              this.edicionAd(adic, id, event);
            }else{
              messages.messageSaving(this.translate.instant('swal.agregandoInfo'),this.translate.instant('swal.espere'))
              var date = (new Date(Meses.getMesesS(per.split('-')[0])+'-1-'+per.split('-')[1]));
              const res = await firstValueFrom(this.actaService.postFile(this.selectedFiles, adic.id, date.toISOString()));
              let aux = {
                id: res.id,
                name: res.name,
                description: res.description,
                path: res.path,
                createdAt: date.toISOString()
              }
              const pr = this.actas.find(p => p.actividades.find(a => a.id === id));
              const ac = pr.actividades.find(a => a.id === id);
              const adG = ac.adicionales.find(a => a.id === adic.id);
              adG.files.push({ ...aux});
              messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
            }
          break;
        }
      }catch(err){
        messages.errorMessageGraph(err);
      }      
    }else{
      messages.errorMessageGraph(this.translate.instant('swal.cancelado'))
    }
  }
  //eliminar archivos
  public async deleteArchivo(){
    const per = this.perSelected();
    const result = await messages.confirmationSave(
      this.translate.instant('swal.confirmarEliminar'),
      this.translate.instant(''),
      this.translate
    );
    if (result) {
      for(const fil of this.adDelete.files){
        if(Meses.obtnerPer(moment(fil.createdAt).toDate()) === per){
          try{
            const res = await firstValueFrom(this.actaService.deleteFile(this.adDelete.id, fil.id));
            const pr = this.actas.find(p => p.actividades.find(a => a.id === this.adActivi.id));
            const ac = pr.actividades.find(a => a.id === this.adActivi.id);
            const adG = ac.adicionales.find(a => a.id === this.adDelete.id);
            adG.files = adG.files.filter(f => f.id !== fil.id); 
            messages.succesMessageGraph(this.translate.instant('swal.swalElimino'));
          }catch(err){
            messages.errorMessageGraph(err);
          }
        }
      }
    }
  }
  // Menu click izquierdo
  public onContextMenu(event: MouseEvent, item, activitie) {
    event.preventDefault(); 
    // we record the mouse position in our object 
    this.menuTopLeftPosition.x = event.clientX + 'px'; 
    this.menuTopLeftPosition.y = event.clientY + 'px'; 

    this.adDelete = item;
    this.adActivi = activitie;
    this.matMenuTrigger.openMenu();
  }
  /** Ordenamiento */
  public ordenamientoTabla(){
    switch(this.ordenamiento){
      case 'id':
        this.actasMostrar = this.ordenamientoAlf(this.actasMostrar);
        this.ordenamiento = 'asc';
      break;
      case 'asc':
        this.actasMostrar = this.ordenamientoAlfInv(this.actasMostrar);
        this.ordenamiento = 'des';
      break;
      case 'des':
        this.actasMostrar = this.ordenamientoPer(this.actasMostrar);
        this.ordenamiento = 'id';
      break;
    }
  }
  /* Exportación a excel */
  public exportarExcelEst(){
    var title = this.translate.instant('gestion.seguimiento.planes.titExcel') + this.Periodo;
    const header = [this.translate.instant('gestion.seguimiento.proy-estra.titTab1'), this.translate.instant('gestion.seguimiento.proy-estra.titTab4'), 
    this.translate.instant('gestion.seguimiento.proy-estra.titTab2'),this.translate.instant('gestion.seguimiento.proy-estra.titTab3'),
    this.translate.instant('gestion.seguimiento.proy-estra.titTab6'),this.translate.instant('gestion.seguimiento.proy-estra.titTab7'), 
    this.translate.instant('gestion.seguimiento.proy-estra.titTab9')];
    const auxData = [];
    for(const acta of this.actasMostrar){
      const ejec = this.avancesProyectos(acta, 'ejec');
      const plan = this.avancesProyectos(acta, 'plan');
      let aux = [];
      if(plan !== 0){
        const fech = this.obtenerFechasPro(acta);
        aux.push(acta.nombre);
        aux.push(acta.responsable.position);
        aux.push(fech[0]);
        aux.push(fech[1]);
        aux.push(plan);
        aux.push(ejec);
        aux.push( this.estatus( this.pintarBordPro(ejec,plan) ) );
        auxData.push(aux);
        aux = [];
        for(const act of acta.actividades){
          const ejecA =  this.avancesProyectosActividad(act, 'ejec');
          const planA =  this.avancesProyectosActividad(act, 'plan');

          const fI = moment(act.fecha_inicio).format('DD-MM-YYYY');
          const fF = moment(act.fecha_fin).format('DD-MM-YYYY');

          aux.push('-'+act.nombre);
          aux.push(act.responsable.position);
          aux.push( fI );
          aux.push( fF );
          aux.push(planA==='rep' || planA==='por'?'-':planA);
          aux.push(ejecA===null || ejecA==='rep' || ejecA==='por'?'-':ejecA);
          aux.push(this.estatus( this.pintarBord(ejecA,planA), ejecA ));
          auxData.push(aux);
          aux = [];
        }
      }
    }
    const NomArch = this.translate.instant('gestion.seguimiento.planes.nombreExcel2');
    this.excelService.generateExcelProyectosAvance(NomArch, header, auxData, this.translate.instant('gestion.seguimiento.planes.nombreExcel3'), this.semaforo);
  }
  private obtenerFechasPro(pro){
    var fecha_fin = undefined;
    var fecha_ini = undefined;
    for(const act of pro.actividades){
      var fI = moment(act.fecha_inicio), fF = moment(act.fecha_fin)
      if(fecha_ini === undefined || fecha_ini.isAfter(fI)){
        fecha_ini = fI;
      }
      if(fecha_fin === undefined || fecha_fin.isBefore(fF)){
        fecha_fin = fF;
      }
      
    }

    return [fecha_ini.format('DD-MM-YYYY'), fecha_fin.format('DD-MM-YYYY')];
  }
  public avancesProyectosActividad(act: any, tipo){
    var per = this.perSelected();
    var porcentajeplan = 0, porcentajeejec = 0;

    const fecPer = moment(Meses.escrituraPer(per), 'MM/DD/YY');
    const actFI = act.fecha_inicio;
    const actFF = act.fecha_fin;
    let historicoEva = undefined;
    if(moment(actFI).isBefore(fecPer) && moment(actFF).isBefore(fecPer) && this.actividadIncompleta(act)){
      historicoEva = act.history.filter(his => his.periodo === per)[0];
      if(historicoEva === undefined){
        if(tipo === 'ejec'){
          return null;
        }
        return 100;
      }
    }else if(moment(actFI).isBefore(fecPer) && moment(actFF).isBefore(fecPer) && !this.actividadIncompleta(act)){
      historicoEva = act.history[act.history.length-1];
    }else if(moment(actFI).isBefore(fecPer) || moment(actFI).isSame(fecPer, 'month')){
      historicoEva = act.history.filter(his => his.periodo === per)[0];
    }else if(moment(actFI).isAfter(fecPer)){
      return 'por';
    }
    const actFilter = this.actividadesFull.filter( a => Number(a.id) === Number(act.id)); 
    const adicionales = actFilter.length !== 0 ? actFilter[0].adicionales:[];
    const ad = adicionales.filter(ad => ad.type === 'texto');

    for(const adic of ad){
      for(const com of adic.comments){
        const fecha = moment(com.created_at.split('T')[0]);
        var percom = Meses.getMesesN(fecha.month()+1) + '-' +(''+fecha.year()).substring(2,4);
        const text = com.comment.toLowerCase();
        if( percom === per &&  text.includes('reprogramada') ){
          return 'rep';
        }
      }
    }

    if(historicoEva !== undefined){
      porcentajeplan = historicoEva.planeado;
      porcentajeejec = historicoEva.ejecutado;
      if(tipo === 'ejec'){
        return porcentajeejec;
      }
      return porcentajeplan;
    }
    return '';
  }
  // public obtEstatus(a){
  //   const act = this.actividadesFull.filter( ac => Number(ac.id) === Number(a.id))[0];

  //   const ejecA =  this.avancesProyectosActividad(act, 'ejec');
  //   const planA =  this.avancesProyectosActividad(act, 'plan');

  //   const dat = this.estatus( this.pintarBord(ejecA,planA), ejecA );
  //   return dat;
  // }
  // public estatusAct(a){
  //   if(!this.allStats){
  //     const act = this.actividadesFull.filter( ac => Number(ac.id) === Number(a.id))[0];

  //     const ejecA =  this.avancesProyectosActividad(act, 'ejec');
  //     const planA =  this.avancesProyectosActividad(act, 'plan');

  //     const dat = this.estatus( this.pintarBord(ejecA,planA), ejecA );

  //     const est = this.estats.filter(es => es.name === dat)[0];
  //     if(est.check){return true}
  //     return false;
  //   }
  //   return true;
  // }
  private estatus(col, estado?){
    if(estado === 'rep'){
      return 'Reprogramada';
    }else if(estado === 'por'){
      return 'Por iniciar';
    }
    switch(col){
      case 'bordeAzul':
      case 'bordeVerde':
        return 'Cumplida';
      case 'bordeRojo':
      case 'bordeNaranja':
        return 'Incumplida';
      case 'bordeAmarillo':
        return 'En proceso';
      case 'bordeGrey':
      case 'bordeGris':
        return 'No iniciada';
      default:
        return '';
    }

  }
  public exportarExcel(){
    var title = this.translate.instant('gestion.seguimiento.planes.titExcel') + this.Periodo;

    var header = [this.translate.instant('gestion.seguimiento.planes.titTab1'), this.translate.instant('gestion.seguimiento.planes.titTab2'), 
    this.translate.instant('gestion.seguimiento.planes.titTab3'),this.translate.instant('gestion.seguimiento.planes.titTab4'),
    this.translate.instant('gestion.seguimiento.planes.titTab5'),this.translate.instant('gestion.seguimiento.planes.titTab6'), 
    this.translate.instant('gestion.seguimiento.planes.titTab7'),this.translate.instant('gestion.seguimiento.planes.titTab8')];
    if(this.actasMostrar[0].actividades[0].adicionales.length !== 0){
      for(var j = 0; j < this.actasMostrar[0].actividades[0].adicionales.length; j++){
        header.push( "" + this.actasMostrar[0].actividades[0].adicionales[j].name );
      }
    }

    var data = [];
    var aux = [];
    for(const acta of this.actasMostrar){
      aux.push( acta.nombre );
      var fecha = this.obtFecha(acta.fecha_ini );
      aux.push( acta.fecha_ini.format('DD/MMM/YYYY'));      
      aux.push( acta.fecha_fin.format('DD/MMM/YYYY') );
      aux.push( acta.responsable.position );
      aux.push( ' ' )
      aux.push( this.escribirDatPro(acta,'plan') );
      aux.push(this.escribirDatPro(acta, 'ejec')===null? 'null':this.escribirDatPro(acta, 'ejec') );
      aux.push( ' ' )
      if(acta.actividades[0].adicionales.length !== 0){
        for(var j = 0; j < acta.actividades[0].adicionales.length; j++){
          aux.push( this.escribirAdicionalPro(acta.actividades,j) );
        }
      }
      data.push(aux);
      aux = [];
      for(const acti of acta.actividades){
        if(this.existAct(acti)){
          aux.push( '-'+acti.nombre )          
          aux.push( acti.fecha_inicio.format('DD/MMM/YYYY') );         
          aux.push( acti.fecha_fin.format('DD/MMM/YYYY') );
          aux.push( acti.responsable.position );
          aux.push( this.avanceAcumulado(acti) )
          aux.push (this.escribirDat(acti.history, 'plan') );
          aux.push( this.escribirDat(acti.history, 'ejec')===null? 'null':this.escribirDat(acti.history, 'ejec') );
          aux.push( this.cumplimiento(acti, '')/100 )
          if(acti.adicionales.length !== 0){
            for(const ad of acti.adicionales){
              aux.push( this.escribirAdicional(ad) );
            }
          }
          data.push(aux);
          aux = [];
        }
      }
    }
    const NomArch = this.translate.instant('gestion.seguimiento.planes.nombreExcel');
    this.excelService.generateExcelPlanes(title, header, data, NomArch, this.semaforo);
  }
  /** Formato de cantidades */
  public formatearnormal(num: any){
    if(num === null){
      return 0;
    }
    num +='';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
    splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    return  splitLeft;
  }
  public formatearConDecimales(num: any){
    num = '' + num.toFixed(2);
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    if (splitRight === '.00')
      return  splitLeft;

    return  splitLeft + splitRight;
  }
  /** Metodos de ordenamiento */
  private ordenamientoPer(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  private ordenamientoAdi(array: any){
    array.sort(function (a: any, b: any) {
      if (a.name > b.name) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  private ordenamientoAlf(array: any){
    array.sort(function (a: any, b: any) {
      if ( a.nombre.toLowerCase() > b.nombre.toLowerCase() ) {
        return 1;
      }
      if ( a.nombre.toLowerCase() < b.nombre.toLowerCase() ) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  private ordenamientoAlfInv(array: any){
    array.sort(function (a: any, b: any) {
      if ( a.nombre.toLowerCase() < b.nombre.toLowerCase() ) {
        return 1;
      }
      if ( a.nombre.toLowerCase() > b.nombre.toLowerCase() ) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  public ordenamientoSem(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.value_00) > Number(b.value_00)) {
        return 1;
      }
      if (Number(a.value_00) < Number(b.value_00)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  public ordenamientoPlaneado(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.planeado) > Number(b.planeado)) {
        return 1;
      }
      if (Number(a.planeado) < Number(b.planeado)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  public ordenamientoId(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  private ordenamientoHis(array){
    array.sort(function (a: any, b: any) {
      let af = moment(Meses.escrituraPer(a.periodo), 'MM/DD/YY');
      let bf = moment(Meses.escrituraPer(b.periodo), 'MM/DD/YY');
      if (bf.isBefore(af)) {
        return 1;
      }
      if (af.isBefore(bf)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  public anchoTabla(){
    let div = Math.trunc(this.actasMostrar.length/4)
    return (65-(div*16))+'vh'
  }
  public avancesProyectos(pro: any, tipo){
    var per = this.perSelected();
    var dias = 0, porcentajeplan = 0, porcentajeejec = 0;
    for(const act of pro.actividades){
      dias += this.obtenerDias(act.fecha_inicio,act.fecha_fin);
    }
    for(const act of pro.actividades){
      const fecPer = moment(Meses.escrituraPer(per));
      let historicoEva = undefined;
      if(moment(act.fecha_inicio).isBefore(fecPer) && moment(act.fecha_fin).isBefore(fecPer) && this.actividadIncompleta(act)){
        historicoEva = act.history.filter(his => his.periodo === per)[0];
        if(historicoEva === undefined){
          historicoEva = {
            ejecutado: null,
            planeado: 100
          };
        }
      }else if(moment(act.fecha_inicio).isBefore(fecPer) && moment(act.fecha_fin).isBefore(fecPer) && !this.actividadIncompleta(act)){
        historicoEva = act.history[act.history.length-1];
      }else if(moment(act.fecha_inicio).isBefore(fecPer) || moment(act.fecha_inicio).isSame(fecPer, 'month')){
        historicoEva = act.history.filter(his => his.periodo === per)[0];
      }
      
      if(historicoEva !== undefined){
        var diasAct = this.obtenerDias(act.fecha_inicio,act.fecha_fin);
        var pesoAct = Number((diasAct*100/dias).toFixed(2));
        porcentajeplan += Number( (historicoEva.planeado*pesoAct/100).toFixed(2));
        if(historicoEva.ejecutado === null || historicoEva.ejecutado === 'null'){
          porcentajeejec += 0;
        }else{
          porcentajeejec += Number((historicoEva.ejecutado*pesoAct/100).toFixed(2));
        }
      }else{
        
      }
    }
    
    porcentajeplan = Number(porcentajeplan.toFixed(2));
    porcentajeejec = Number(porcentajeejec.toFixed(2));
    if(tipo === 'ejec'){
      return porcentajeejec;
    }
    return porcentajeplan
  }
  public cumplimiento(item, clase){
    let ejec = 0, plan = 0;
    if(clase === 'plan'){
      const ejec = this.avancesProyectos(item, 'ejec');
      const plan = this.avancesProyectos(item, 'plan');
      return Number((ejec*100/plan).toFixed(2));
    }else{
      ejec = this.escribirDat(item.history, 'ejec');
      plan = this.escribirDat(item.history, 'plan');
    }

    return Number((ejec*100/plan).toFixed(2));
  }
  public texto(valor: any){
    var color = '';
    if(valor != 0){
      var valfin = 0;
      for(const sem of this.semaforo){
        if(valfin < sem.valfin){
          valfin = sem.valfin
        }
      }
      if(valor >= valfin){
        valor = valfin-1;
      }
      for(const sem of this.semaforo){
        var ab = sem.valIn;
        if(ab !== 0){
          ab = ab-0.1;
        }
        if(valor >= ab && valor < sem.valfin){
          color = sem.color;
          break;
        }
      }
    }
    switch(color){
      case 'verde': return 'cifraSecVerd';
      case 'azul': return 'cifraSecAzul';
      case 'amarillo': return 'cifraSecAmar';
      case 'naranja': return 'cifraSecNarj';
      case 'rojo': return 'cifraSecRojo';
      default:  return 'cifraSecGris';
    }
  }
}
